import React from "react";
import styled from "styled-components";
import LottieLoadingIndicator from "./LottieLoadingIndicator";

const StyledLoadingActionButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: ${p => p.minWidth || p.width || "140px"};
    width: ${p => p.width || "auto"};
    height: ${p => p.height || "38px"};
    padding: ${p => p.padding || "0 1.1rem"};
    border: ${p => p.border || "none"};
    border-radius: ${p => p.borderRadius || "7px"};
    background: ${p => p.background || p.backgroundColor || "#171A22"};
    color: ${p => p.color || "#ffffff"};
    font: ${p => p.font || "normal normal 700 12px/16px Manrope, Helvetica, sans-serif"};
    box-shadow: ${p => p.boxShadow || "none"};
    cursor: ${p => p.disabled ? "not-allowed" : "pointer"};
    opacity: ${p => p.disabled && !p.$isLoading ? 0.52 : 1};
`;

export default function LoadingActionButton({ children, isLoading, loadingHeight = "2rem", loadingWidth = "2rem", disabled, ...props }) {
    return (
        <StyledLoadingActionButton disabled={disabled || isLoading} $isLoading={isLoading} {...props}>
            {isLoading
                ? <LottieLoadingIndicator height={loadingHeight} width={loadingWidth} margin="5px" containerHeight={loadingHeight} />
                : children}
        </StyledLoadingActionButton>
    );
}
